import { render, staticRenderFns } from "./WarningHeader.vue?vue&type=template&id=3595fe84&scoped=true"
var script = {}
import style0 from "./WarningHeader.vue?vue&type=style&index=0&id=3595fe84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595fe84",
  null
  
)

export default component.exports